module.exports = __webpack_public_path__ + "static/img/p1.ea51bcd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school/p1.png
// module id = G8e0
// module chunks = 1